import React from 'react'

const ArrowIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" className='hover:scale-110'><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"/></svg>
    )
}

export default ArrowIcon